import type { ColorIndicator } from '@disco/utils/color-indicators'
import { COLORS } from '@disco/utils/color-indicators'

import type { NativeTag } from 'types/track'

// Anything a color dot can be drawn for: native and playlist tags are
// different shapes, so this is only the fields the dot itself reads.
export type TagWithColor = {
  id: number
  name: string
  color: ColorIndicator | null | undefined
}

// A native tag narrowed to one whose color resolves in the shared palette.
export type ColoredTag = NativeTag & { color: ColorIndicator }

export const resolveIndicatorColor = (
  color: ColorIndicator | null | undefined,
): string | undefined => (color ? COLORS[color] : undefined)

// A dot has no shape of its own, so a tag with a missing or retired color would
// render as an invisible gap in the cluster. Drop those rather than draw them.
export const getColoredTags = (
  tags: NativeTag[] | null | undefined,
): ColoredTag[] =>
  (tags ?? []).filter((tag): tag is ColoredTag =>
    Boolean(resolveIndicatorColor(tag.color)),
  )
